<template>

  <ControlloAcquistatoVenduto />
 
</template>

<script>
import ControlloAcquistatoVenduto from '../components/pratiche/ControlloAcquistatoVenduto.vue'

export default {
  pageName: 'fatture',
  components: {
    ControlloAcquistatoVenduto

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
